import {createContext} from "react"

export const StoreContext = createContext({store:{id:'',name:''}, setStore:()=>{}});

